import axios from 'axios'
import initializers from '../../dependencies/initializers'
import _ping from '../../dependencies/_ping'
import { change } from 'redux-form';


function checkPing(){
	var start = new Date().getTime();
	const timeout = new Promise((resolve, reject) => {
		setTimeout(reject, 1000, "Request timed out");
	});
	const options = {
		url: "/astro-jobs"
	};
	const request = _ping(options);
	return Promise.race([timeout, request])
      .then(response => {
				console.log('ping success')
      })
      .catch(error => {
        let end = new Date().getTime();
        let time = end - start;
        let reason = "Timeout";
				console.log('timeout')
				// cb('Timeout')
        // this.setState({ isConnected: false });
        //  this.decideMainLayout("timed-out")
      });
}




export function docAttachmentSuccess(file_attachment){
	return{
		type:'DOCUMENT_ADD_FILE_ATTACHMENT_SUCCESS',
		file_attachment
	}
}

export function docAttachment(file_attachment){
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(docAttachmentSuccess(file_attachment)))
		})
	}
}

export function send(company_id,file,extension,fileName,curr_index,end,start,size,new_file){
	return (dispatch,getState) => {
		
		return new Promise((resolve, reject) => {


					const formData = new FormData();
					let file_size = size 
					const CancelToken = axios.CancelToken
					const cancelTokenSource = CancelToken.source()
					let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
					//to cancel set up cancelTokenSource into reducer 
					//operat by cancelTokenSource.cancel()
					const end_point = initializers.api_host+`/companies/${company_id}/upload`;
					formData.append('dataFile',file)
					formData.append('extension',extension)
					formData.append('fileName',fileName)
					formData.append('identifier',docAttachmentUpdated[curr_index]['identifier'])
					formData.append('size',size)
					formData.append('end',end)
					formData.append('isNewFile',new_file)
					
					// curr_index itu adalah reducerIndexattachmentnya
					const startTime = new Date().getTime();
					
					docAttachmentUpdated[curr_index]['tokenCancel'] = cancelTokenSource;
					
					dispatch(dispatch(docAttachmentSuccess(docAttachmentUpdated)))

					return axios({
										url:end_point,
										method: "post",
										timeout: 200000,
										data:formData,
										cancelToken: cancelTokenSource.token,
										headers: {
											'Content-Type': 'application/json',
										},
					})
					.then((response)=>{
						const {filepath} = response.data

						//check upload speed
						let endTime = new Date().getTime();
						let time = endTime - startTime;
						const uploadTime = time / 1000.0;
						const bitsLoaded = 1000024 * 8;
						var speedBps = (bitsLoaded / uploadTime).toFixed(2);
						var speedKbps = (speedBps / 1024).toFixed(2);
						var speedMbps = (speedKbps / 1024).toFixed(2);
						console.log(speedMbps,'speed nya bits')
						//

						//estimation time 
						const file_size_inbps = file_size * 8
						const estimation_in_minutes = (file_size_inbps/speedBps)/60
					

						console.log(estimation_in_minutes,'estimasi dalam menit')

						let file_unit_value = 'MB'
						console.log(end,'end')
						console.log(file_size,'file_size')
						let percentage = Math.round((end/file_size)*100)
					
						let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
						docAttachmentUpdated[curr_index]['startSize'] = start;
						docAttachmentUpdated[curr_index]['endSize'] = end;
						//progressFile show ex 1,8 MB of 3,5 MB
						docAttachmentUpdated[curr_index]['progressFile'] = Math.round(end / 1028576)
						docAttachmentUpdated[curr_index]['progress'] = percentage
						docAttachmentUpdated[curr_index]['progressUnit'] = 'MB'
						if (end == file_size) {
							docAttachmentUpdated[curr_index]['progress'] = 100
							docAttachmentUpdated[curr_index]['status'] = 'finish'
						}
						if (filepath) {
							docAttachmentUpdated[curr_index]['showBarProgress'] = 0
							docAttachmentUpdated[curr_index]['filepath'] = filepath
						}else if(speedMbps <= 0.3){
							
							console.log(speedMbps)
							docAttachmentUpdated[curr_index]['status'] = 'paused'
							dispatch(dispatch(docAttachmentSuccess(docAttachmentUpdated)))
							reject('speed low')
						}
						dispatch(dispatch(docAttachmentSuccess(docAttachmentUpdated)))

						if (estimation_in_minutes > 5 ) {
							resolve('longupload')
						}
						if (curr_index==0) {
							const {content} = response.data
						
								if (content.status == 200) {
									const {profile} = content.response.data

									dispatch(change('CompanyJobDetailByCode', 'fullname', profile.name.trim()));
									dispatch(change('CompanyJobDetailByCode', 'preferred_name', (profile.preferred || profile.name.trim())));
									dispatch(change('CompanyJobDetailByCode', 'email', profile.email.trim()));
									dispatch(change('CompanyJobDetailByCode', 'phone', profile.phone.trim()));
									dispatch(change('CompanyJobDetailByCode', 'cv_raw_content', content.response.data))
								}
							
							
							

						}
						resolve('ok')

					})
					.catch((error)=>{
						if (error == 'canceled') {
							console.log('Request canceled', error.message)
						}else{
							console.log('masuk sini')
							let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
							
							docAttachmentUpdated[curr_index]['status'] = 'failed'
							dispatch(docAttachmentSuccess(docAttachmentUpdated))
							reject('time out')
						
						}
					
					})
		})
					

	}
}

export function docAttachmentUpload(company_id,file,curr_index,indexDocument,up_time=null){
	return (dispatch,getState) => {

	
		//file size
		let file_size = file.size / 1028576  //in MB
		
			const CancelToken = axios.CancelToken
			const source = CancelToken.source()
			const end_point = initializers.api_host+`/companies/${company_id}/multi_document_save`;
			const formData = new FormData();
			if (indexDocument==0) {
				formData.append('is_cv',1)
			}
			formData.append('file',file)
			const upload_id = Math. floor(Math. random() * 100)
			let canceled = 0;
			let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
			docAttachmentUpdated[curr_index]['tokenCancel'] = source;
			dispatch(dispatch(docAttachmentSuccess(docAttachmentUpdated)))
			return 	axios({
						url:end_point,
						method: "post",
						timeout: 200000,
						data:formData,
						cancelToken: source.token,
						onUploadProgress: progressEvent => {
							checkPing()
							let file_unit_value = 'MB'
							const uploadPercentage = Math.round(
								(progressEvent.loaded * 100) / progressEvent.total
							);
							let size_uploaded = Math.round(uploadPercentage/100 * file_size)
							
							let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
							
							if (docAttachmentUpdated[curr_index]) {
								if (up_time) {
									if (up_time != docAttachmentUpdated[curr_index]['lastModified']) {
										source.cancel('Operation canceled by the user.');
										canceled = 1
									}
								}
								
							}else{
								source.cancel('Operation canceled by the user.');
								canceled = 1
							}
							
							if (!canceled) {
								// console.log(docAttachmentUpdated[curr_index])
								if (progressEvent.loaded != progressEvent.total) {
									docAttachmentUpdated[curr_index]['progress'] = uploadPercentage
									if (size_uploaded < 1) {
										size_uploaded = Math.round(uploadPercentage/100 * (file.size / 1028))
										file_unit_value = 'KB'
									}
	
									docAttachmentUpdated[curr_index]['progressFile'] = size_uploaded
									docAttachmentUpdated[curr_index]['progressUnit'] = file_unit_value
								}
	
								
								
								
								
								
								dispatch(docAttachmentSuccess(docAttachmentUpdated))
							}
					

						},
					})
					.then((response)=>{
							const {filepath} = response.data
						
						
							let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
							const publicJobDetail  = getState().publicJobDetail.toJS();
							const translations = publicJobDetail.translation || [];
							
						
							if (indexDocument==0) {
								const {content} = response.data
							
									if (content.status == 200) {

											
											const {profile} = content.response.data
										
											dispatch(change('CompanyJobDetailByCode', 'fullname', profile.name.trim()));
											dispatch(change('CompanyJobDetailByCode', 'preferred_name', (profile.preferred || profile.name.trim())));
											dispatch(change('CompanyJobDetailByCode', 'email', profile.email.trim()));
											dispatch(change('CompanyJobDetailByCode', 'phone', profile.phone.trim()));
											dispatch(change('CompanyJobDetailByCode', 'cv_raw_content', content.response.data))	
									
										
									}else{
											const {message} = content.response
											console.log(message)
											if (message) {
												const errMessage = translations['LABEL_CV_UNRESOLVED']
												const status = "failed"
												docAttachmentUpdated[curr_index]['errorMessage'] = errMessage
												docAttachmentUpdated[curr_index]['status'] = status
											}

											console.log(docAttachmentUpdated,'masuk sini')
											dispatch(docAttachmentSuccess(docAttachmentUpdated))
											dispatch(change('CompanyJobDetailByCode', 'cv_raw_content', content.response.data))	
											return;
									}
							

							}

							
							docAttachmentUpdated[curr_index]['progressFile'] = docAttachmentUpdated[curr_index]['sizeFile']
							docAttachmentUpdated[curr_index]['progressUnit'] = docAttachmentUpdated[curr_index]['sizeUnit']
							docAttachmentUpdated[curr_index]['progress'] = 100
							docAttachmentUpdated[curr_index]['status'] = 'finish'
							docAttachmentUpdated[curr_index]['filepath'] = filepath
							dispatch(docAttachmentSuccess(docAttachmentUpdated))
							
						setTimeout(() => {
							docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
							if (docAttachmentUpdated[curr_index]) {
								docAttachmentUpdated[curr_index]['showBarProgress'] = 0
							  }
							dispatch(docAttachmentSuccess(docAttachmentUpdated))
						}, 3000);
					})
					.catch((error)=>{
						console.log(error, 'error')
						if (error == 'canceled') {
							console.log('Request canceled', error.message)
						}else{
							console.log('masuk sini')
							let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
							
							docAttachmentUpdated[curr_index]['status'] = 'failed'
							dispatch(docAttachmentSuccess(docAttachmentUpdated))
						
						}
					
					})
				// })
	}
}


export function retrieveCVtoParsed(cvUrl){
	return(dispatch,getState)=>{

		const end_point = `https://cv.astrnt.co/api/parse`;
		const formData = new FormData();
			formData.append('file_url',cvUrl)
		return axios({
			url:end_point,
			method: "post",
			timeout: 200000,
			data:formData,
		})
		.then((response)=>{
			const {data} = response.data
			const{profile,education,workExperiences} = data

			dispatch(change('CompanyJobDetailByCode', 'fullname', profile.name));
			dispatch(change('CompanyJobDetailByCode', 'preferred_name', profile.email));
			dispatch(change('CompanyJobDetailByCode', 'email', profile.email));
			dispatch(change('CompanyJobDetailByCode', 'phone', profile.phone));

		})
	}
}